import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { map, take } from 'rxjs/operators';
import { setClassMetadata } from '@angular/core/src/r3_symbols';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class InvoicingResolve implements Resolve<any> {
  constructor(private authService: AuthService, private apiHelper: ApiHelper) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    let sessionResolve = this.authService.checkSession();
    return sessionResolve.pipe(
      take(1),
      map((data) => data),
    );
  }
}
